// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Root variables for consistent theming */
:root {
  --color-background-light: #f8fafc;
  --color-sidebar-bg: #ffffff;
  --color-primary: #4f46e5;
  --color-text: #1f2937;
  --color-overlay: rgba(0, 0, 0, 0.5);
}

/* Layout Styles */
.layout {
  display: flex;
  width: 100%;
  height: 100vh;
  overflow: hidden;
  background-color: var(--color-background-light);
}

/* Sidebar Styles */
.sidebar {
  width: 280px;
  background-color: var(--color-sidebar-bg);
  transition: width 0.3s ease-in-out, transform 0.3s ease-in-out;
  flex-shrink: 0;
  position: fixed;
  height: 100%;
  z-index: 50;
  box-shadow: 2px 0 10px rgba(0, 0, 0, 0.1);
  backdrop-filter: blur(5px);
  -webkit-backdrop-filter: blur(5px);
}

.sidebar.collapsed {
  width: 100px;
}

.sidebar .sidebar-text {
  opacity: 1;
  transition: opacity 0.3s ease-in-out;
  white-space: nowrap;
  overflow: hidden;
}

.sidebar.collapsed .sidebar-text {
  opacity: 0;
  width: 0;
}

/* Content Area */
.content-area {
  flex-grow: 1;
  display: flex;
  flex-direction: column;
  min-height: 100vh;
  transition: margin-left 0.3s ease-in-out;
}

/* Adjust content area based on sidebar state */
.content-area.not-expanded {
  margin-left: 280px; /* Matches sidebar expanded width */
}

.content-area.expanded {
  margin-left: 100px; /* Matches sidebar collapsed width */
}

/* Main Content */
.content-area main {
  flex-grow: 1;
  overflow-y: auto;
  padding: 1rem;
}

/* Overlay for Mobile Sidebar */
.overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: var(--color-overlay);
  z-index: 40;
  opacity: 0;
  visibility: hidden;
  transition: opacity 0.3s ease-in-out, visibility 0.3s ease-in-out;
}

.overlay.active {
  opacity: 1;
  visibility: visible;
}

/* Mobile and Tablet Adjustments */
@media (max-width: 1023px) {
  .sidebar {
    width: 280px;
    transform: translateX(-100%);
  }

  .sidebar.mobile-open {
    transform: translateX(0);
  }

  .content-area.expanded,
  .content-area.not-expanded {
    margin-left: 0;
  }

  .content-area.mobile-sidebar-open {
    margin-left: 0;
    pointer-events: none; /* Prevent interaction with content when sidebar is open */
  }

  .content-area.mobile-sidebar-open main {
    filter: blur(4px); /* Subtle blur effect when sidebar is open */
  }

  .sidebar.collapsed {
    width: 280px; /* Keep full width for mobile slide-in */
  }

  .sidebar .sidebar-text {
    opacity: 1; /* Always show text on mobile when open */
  }
}

@media (max-width: 767px) {
  .sidebar {
    width: 250px; /* Slightly narrower for mobile */
  }

  .content-area main {
    padding: 0.5rem; /* Reduced padding for mobile */
  }
}`, "",{"version":3,"sources":["webpack://./src/newtest/Layout/Layout.css"],"names":[],"mappings":"AAAA,0CAA0C;AAC1C;EACE,iCAAiC;EACjC,2BAA2B;EAC3B,wBAAwB;EACxB,qBAAqB;EACrB,mCAAmC;AACrC;;AAEA,kBAAkB;AAClB;EACE,aAAa;EACb,WAAW;EACX,aAAa;EACb,gBAAgB;EAChB,+CAA+C;AACjD;;AAEA,mBAAmB;AACnB;EACE,YAAY;EACZ,yCAAyC;EACzC,8DAA8D;EAC9D,cAAc;EACd,eAAe;EACf,YAAY;EACZ,WAAW;EACX,yCAAyC;EACzC,0BAA0B;EAC1B,kCAAkC;AACpC;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,UAAU;EACV,oCAAoC;EACpC,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,UAAU;EACV,QAAQ;AACV;;AAEA,iBAAiB;AACjB;EACE,YAAY;EACZ,aAAa;EACb,sBAAsB;EACtB,iBAAiB;EACjB,wCAAwC;AAC1C;;AAEA,+CAA+C;AAC/C;EACE,kBAAkB,EAAE,mCAAmC;AACzD;;AAEA;EACE,kBAAkB,EAAE,oCAAoC;AAC1D;;AAEA,iBAAiB;AACjB;EACE,YAAY;EACZ,gBAAgB;EAChB,aAAa;AACf;;AAEA,+BAA+B;AAC/B;EACE,eAAe;EACf,MAAM;EACN,OAAO;EACP,WAAW;EACX,YAAY;EACZ,sCAAsC;EACtC,WAAW;EACX,UAAU;EACV,kBAAkB;EAClB,iEAAiE;AACnE;;AAEA;EACE,UAAU;EACV,mBAAmB;AACrB;;AAEA,kCAAkC;AAClC;EACE;IACE,YAAY;IACZ,4BAA4B;EAC9B;;EAEA;IACE,wBAAwB;EAC1B;;EAEA;;IAEE,cAAc;EAChB;;EAEA;IACE,cAAc;IACd,oBAAoB,EAAE,0DAA0D;EAClF;;EAEA;IACE,iBAAiB,EAAE,4CAA4C;EACjE;;EAEA;IACE,YAAY,EAAE,wCAAwC;EACxD;;EAEA;IACE,UAAU,EAAE,yCAAyC;EACvD;AACF;;AAEA;EACE;IACE,YAAY,EAAE,iCAAiC;EACjD;;EAEA;IACE,eAAe,EAAE,+BAA+B;EAClD;AACF","sourcesContent":["/* Root variables for consistent theming */\n:root {\n  --color-background-light: #f8fafc;\n  --color-sidebar-bg: #ffffff;\n  --color-primary: #4f46e5;\n  --color-text: #1f2937;\n  --color-overlay: rgba(0, 0, 0, 0.5);\n}\n\n/* Layout Styles */\n.layout {\n  display: flex;\n  width: 100%;\n  height: 100vh;\n  overflow: hidden;\n  background-color: var(--color-background-light);\n}\n\n/* Sidebar Styles */\n.sidebar {\n  width: 280px;\n  background-color: var(--color-sidebar-bg);\n  transition: width 0.3s ease-in-out, transform 0.3s ease-in-out;\n  flex-shrink: 0;\n  position: fixed;\n  height: 100%;\n  z-index: 50;\n  box-shadow: 2px 0 10px rgba(0, 0, 0, 0.1);\n  backdrop-filter: blur(5px);\n  -webkit-backdrop-filter: blur(5px);\n}\n\n.sidebar.collapsed {\n  width: 100px;\n}\n\n.sidebar .sidebar-text {\n  opacity: 1;\n  transition: opacity 0.3s ease-in-out;\n  white-space: nowrap;\n  overflow: hidden;\n}\n\n.sidebar.collapsed .sidebar-text {\n  opacity: 0;\n  width: 0;\n}\n\n/* Content Area */\n.content-area {\n  flex-grow: 1;\n  display: flex;\n  flex-direction: column;\n  min-height: 100vh;\n  transition: margin-left 0.3s ease-in-out;\n}\n\n/* Adjust content area based on sidebar state */\n.content-area.not-expanded {\n  margin-left: 280px; /* Matches sidebar expanded width */\n}\n\n.content-area.expanded {\n  margin-left: 100px; /* Matches sidebar collapsed width */\n}\n\n/* Main Content */\n.content-area main {\n  flex-grow: 1;\n  overflow-y: auto;\n  padding: 1rem;\n}\n\n/* Overlay for Mobile Sidebar */\n.overlay {\n  position: fixed;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  background-color: var(--color-overlay);\n  z-index: 40;\n  opacity: 0;\n  visibility: hidden;\n  transition: opacity 0.3s ease-in-out, visibility 0.3s ease-in-out;\n}\n\n.overlay.active {\n  opacity: 1;\n  visibility: visible;\n}\n\n/* Mobile and Tablet Adjustments */\n@media (max-width: 1023px) {\n  .sidebar {\n    width: 280px;\n    transform: translateX(-100%);\n  }\n\n  .sidebar.mobile-open {\n    transform: translateX(0);\n  }\n\n  .content-area.expanded,\n  .content-area.not-expanded {\n    margin-left: 0;\n  }\n\n  .content-area.mobile-sidebar-open {\n    margin-left: 0;\n    pointer-events: none; /* Prevent interaction with content when sidebar is open */\n  }\n\n  .content-area.mobile-sidebar-open main {\n    filter: blur(4px); /* Subtle blur effect when sidebar is open */\n  }\n\n  .sidebar.collapsed {\n    width: 280px; /* Keep full width for mobile slide-in */\n  }\n\n  .sidebar .sidebar-text {\n    opacity: 1; /* Always show text on mobile when open */\n  }\n}\n\n@media (max-width: 767px) {\n  .sidebar {\n    width: 250px; /* Slightly narrower for mobile */\n  }\n\n  .content-area main {\n    padding: 0.5rem; /* Reduced padding for mobile */\n  }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
